import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge only knows Tailwind's default t-shirt font sizes, so our type scale
 * (`text-body`, `text-cell`, …) would be classified as text *colours* and made to fight
 * `text-on-accent` / `text-fg-muted` for the same slot, dropping whichever came first.
 * Registering the scale from tokens.css keeps size and colour in separate groups.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["title", "section", "body", "cell", "caption"],
    },
  },
});

/** Class composition for the primitives and product components. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
